
import ready from './utilities/ready';
import invokeBootstrap from './components/bootstrap';
import invokeKeenSlider from './components/keen-slider';
import invokeColorPicker from './components/colorpicker';
import invokeDoubleClick from './components/double-click';
import invokeStickyHeader from './components/sticky-header';
import invokeScrollToTop from './components/to-top';
import invokeLightbox from './components/lightbox';

ready(invokeBootstrap);
ready(invokeKeenSlider);
ready(invokeColorPicker);
ready(invokeDoubleClick);
ready(invokeStickyHeader);
ready(invokeScrollToTop);
ready(invokeLightbox);
